// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_dx-6";
export var emphasizeQuantity = "_dx-3";
export var flatBottomCorners = "_dx-5";
export var productImage = "_dx-0";
export var quantityContainer = "_dx-2";
export var tooltip = "_dx-1";
export var wrapAndEllipsesOverflow = "_dx-4";